import type { TemplateFormName } from "./types";

export interface TemplateForm {
  id: TemplateFormName;
  title: string;
  usedInStep: number;
  usedInLabel: string;
  completedBy: string;
  conditional: boolean;
  conditionalNote?: string;
  instructions: string;
}

export const templateForms: TemplateForm[] = [
  {
    id: "school-certification",
    title: "School Certification Form",
    usedInStep: 2,
    usedInLabel: "Step 2 — Basic Information",
    completedBy: "School counselor",
    conditional: false,
    instructions:
      "Download this template, have it completed and signed by your school counselor, then upload the signed form here.",
  },
  {
    id: "physician-statement",
    title: "Physician's Statement / Physical Exam",
    usedInStep: 3,
    usedInLabel: "Step 3 — Health History",
    completedBy: "Physician",
    conditional: false,
    instructions:
      "Download the template, have it completed by your physician within the past 12 months, then upload it (or upload a physical exam from a provider covering the same information).",
  },
  {
    id: "asthma-action-plan",
    title: "Asthma Action Plan",
    usedInStep: 3,
    usedInLabel: "Step 3 — Health History",
    completedBy: "Physician",
    conditional: true,
    conditionalNote: "Required only if the student has asthma",
    instructions:
      "Download this form, have it completed by your physician, then upload it here.",
  },
  {
    id: "medication-authorization",
    title: "Physician Medication Authorization",
    usedInStep: 3,
    usedInLabel: "Step 3 — Health History",
    completedBy: "Physician",
    conditional: true,
    conditionalNote: "Required only if the student will take medications during the session",
    instructions:
      "Because you entered one or more medications, this form must be completed by your physician and uploaded here.",
  },
  {
    id: "financial-responsibility",
    title: "Agreement of Financial Responsibility",
    usedInStep: 5,
    usedInLabel: "Step 5 — Certifications",
    completedBy: "Parent/guardian",
    conditional: false,
    instructions: "Download, have a parent/guardian sign, then upload the completed form.",
  },
  {
    id: "liability-waiver",
    title: "Release and Waiver of Liability Agreement",
    usedInStep: 5,
    usedInLabel: "Step 5 — Certifications",
    // Round 48 — the approved waiver is signed in ink by the participant AND a
    // parent/guardian (owner decision D2, 2026-10-11).
    completedBy: "Participant and parent/guardian",
    conditional: false,
    instructions:
      "Download, have the participant and a parent/guardian sign in ink, then upload every signed page.",
  },
];
